import Link from 'next/link';
import { EduHubArticleResult } from 'types/studio/eduHub';
import { Typography } from '@ag1/ui';
import { StudioHotspotImageV2 } from 'shared/studio/StudioHotspotImage/StudioHotspotImage';
import { routes } from '@portal/constants/routes';
import styles from './EduArticleCard.module.scss';

interface Props {
  card: EduHubArticleResult;
  lazyLoadingImage?: boolean;
}

export const EduArticleCard = ({ card, lazyLoadingImage = true }: Props) => {
  const { eduHubPost, eduHub } = routes;
  return (
    <Link
      as={eduHubPost({ slug: card?.slug?.current || eduHub })}
      href={eduHubPost({ slug: card?.slug?.current || eduHub })}
      className={styles.card}>
      {card.coverImage && (
        <StudioHotspotImageV2
          className={styles.imageCont}
          image={card.coverImage}
          eagerLoading={!lazyLoadingImage}
        />
      )}
      <div className={styles.text}>
        <Typography
          variant="body"
          component="h3"
          size="2"
          color="black-new"
          noPadding
          className={styles.headline}>
          {card.headline}
        </Typography>
        <Typography variant="body" size="3" className={styles.category} noPadding>
          {card?.category?.title}
        </Typography>
      </div>
    </Link>
  );
};
